import React from "react";
import Emojis from "./emojis/Emojis";
const Copied = ({ show, emoji }) => {
  return (
    <>
      {show && (
        <div className="copied">
          <div className="overly">
            <div className="wrapper">
              <div className="content">
                <div>
                  PASTE IT <Emojis data={emoji} />
                </div>
                <div className="code-emoji">
                  <span className="bracket-emoji">{"<"}</span>
                  <span className="tag-emoji">Emojis </span>
                  <span className="data-emoji">data=</span>
                  <span className="id-emoji">{`"${emoji}"`}</span>
                  <span className="bracket-emoji">{" />"}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Copied;
